import { Link } from 'react-router-dom';
import { bg1 } from '../../assets';

export default function HeroHeader() {

  return (
    <div className="relative overflow-hidden bg-white dark:bg-gray-900 dark:text-gray-100">

      {/* Hero Content */}
      <div className="container relative mx-auto grid grid-cols-1 gap-16 px-4 py-16 text-center lg:grid-cols-2 lg:px-8 lg:py-32 lg:text-left xl:max-w-7xl">
        <div className="lg:flex lg:items-center">
          <div>
            <div className="mb-2 inline-flex rounded border border-emerald-200 bg-emerald-100 px-2 py-1 text-sm font-medium leading-4 text-emerald-800 dark:border-emerald-800/50 dark:bg-emerald-900/50 dark:text-emerald-200">
              Our First Version is live!
            </div>
            <h1 className="mb-4 text-4xl font-black text-black dark:text-white">
              Solving Curbside Parking Problems One City At A Time
            </h1>
            <h2 className="text-xl font-medium leading-relaxed text-gray-700 dark:text-gray-300">
              Our technology, born from a commitment to redefine curb management, uses cutting-edge AI to process street videos from off-the-shelf dashcams.
              Join us to explore the simplicity, efficiency, and commitment to a greener future embedded in Ai4Curb!
            </h2>
            <div className="flex flex-col justify-center space-y-2 pb-16 pt-10 sm:flex-row sm:items-center sm:space-x-2 sm:space-y-0 lg:justify-start">
              <Link to="/inventory"
                className="inline-flex items-center justify-center space-x-2 rounded-lg border border-teal-700 bg-teal-700 px-7 py-3.5 font-semibold leading-6 text-white hover:border-teal-600 hover:bg-teal-600 hover:text-white focus:ring focus:ring-teal-400 focus:ring-opacity-50 active:border-teal-700 active:bg-teal-700 dark:focus:ring-teal-400 dark:focus:ring-opacity-90"
            //className="inline-flex items-center justify-center space-x-2 rounded-lg border border-primary-700 bg-primary-700 px-7 py-3.5 font-semibold leading-6 text-white hover:border-primary-600 hover:bg-primary-600 hover:text-white focus:ring focus:ring-primary-400 focus:ring-opacity-50 active:border-primary-700 active:bg-primary-700 dark:focus:ring-primary-400 dark:focus:ring-opacity-90"
              >
                <span>Inventory Management</span>
                <svg
                  className="hi-mini hi-arrow-right inline-block size-5 opacity-50"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z"
                    clipRule="evenodd"
                  />
                </svg>
              </Link>
              {/* <Link
                to="/#"
                className="inline-flex items-center justify-center space-x-2 rounded-lg border border-gray-200 bg-white px-7 py-3.5 font-semibold leading-6 text-gray-800 hover:border-gray-300 hover:text-gray-900 hover:shadow-sm focus:ring focus:ring-gray-300 focus:ring-opacity-25 active:border-gray-200 active:shadow-none dark:border-gray-700 dark:bg-transparent dark:text-gray-300 dark:hover:border-gray-600 dark:hover:text-gray-200 dark:focus:ring-gray-600 dark:focus:ring-opacity-40 dark:active:border-gray-700"
              >
                <span>Learn More</span>
              </Link> */}
            </div>
          </div>
        </div>
        <div className="lg:flex lg:items-center lg:justify-center">
        {/* <img src={bg1} alt="background mission" className="w-full h-auto mb-4" /> */}

          <div className="relative lg:w-96">
            <div className="bg-tranparent absolute right-0 top-0 -m-6 size-40 rounded-full border border-teal-200 lg:size-96 dark:border-teal-900" />
            <div className="bg-tranparent absolute bottom-0 left-0 -m-6 size-40 rounded-full border border-indigo-200 lg:size-96 dark:border-indigo-900" />
            <div className="absolute left-0 top-0 -ml-10 -mt-10 size-36 rounded-full bg-gradient-to-br from-purple-200 dark:from-purple-800" />
            <div className="absolute bottom-0 right-0 -mb-8 -mr-8 size-24 rotate-12 rounded-3xl bg-gradient-to-tl from-amber-200 dark:from-orange-900" />
            <div className="absolute right-0 top-0 -mr-8 -mt-10 h-40 w-32 -rotate-6 rounded-3xl bg-gradient-to-bl from-teal-200 dark:from-teal-800" />
            <div className="absolute bottom-0 left-0 -mb-8 -ml-8 h-40 w-32 rotate-12 rounded-3xl bg-gradient-to-tr from-indigo-200 dark:from-indigo-800" />
            {/* <img
              src="https://cdn.tailkit.com/media/placeholders/photo-MChSQHxGZrQ-800x1000.jpg"
              className="relative mx-auto rounded-lg shadow-lg"
              alt="Hero Image"
            /> */}
            
            <img src={bg1} alt="background mission" className="w-full h-auto mb-4" />

          </div>
        </div>
      </div>
      {/* END Hero Content */}
    </div>
  )
}